module.exports = __webpack_public_path__ + "img/13 sola.016f04fe.jpg";